import React, { useEffect, useState } from "react";
import { Box, Typography, Grid, Card, Tabs, Tab } from "@mui/material";
import Header from "../../components/header";
import PasswordUpdate from "./PasswordUpdate";
import ParentWrapper from "../../components/ParentWrapper";


function Settings() {
  // const [tabValue, setTabValue] = useState(0);

  // const handleTabChange = (event, newValue) => {
  //   setTabValue(newValue);
  // };

  return (
    <>
      {/* <Box sx={{ pt: { xs: "0px", md: "0px" }, bgcolor: "" }}>
        <Box>
          <Box
            sx={{
              ml: {
                xs: "0px",
                md: "230px",
              },
              p: 3
            }}
          > */}
      <ParentWrapper>



        <Box
          sx={{
            display: {
              xs: "none",
              md: "initial",
            },
          }}
        >
          {/* <Header title={"Settings"} subHeading={"Manage your Account here"} /> */}
        </Box>
        <Grid
          container
          sx={{
            mb: 2,
            // p: 2,
            // mt: {
            //   xs: 0,
            //   md: 1,
            // },
          }}
        >
          <Box sx={{ width: "100%" }}>
            {/* <Tabs
                  value={tabValue}
                  onChange={handleTabChange}
                  textColor="primary"
                  indicatorColor="primary"
                  sx={{
                    "& .MuiTabs-indicator": {
                      backgroundColor: "#6366F1",
                    },
                    "& .MuiTab-root.Mui-selected": {
                      color: "#6366F1",
                    },
                  }}
                >
                  <Tab label="Change Password" />
                </Tabs> */}

            {<PasswordUpdate />}
          </Box>
        </Grid>

      </ParentWrapper>
      {/* </Box>
        </Box>
      </Box> */}
    </>
  );
}

export default Settings;
